
import { useTranslation } from "react-i18next";

import DOCOnlineEducationForm from "./DOCOnlineEducationForm";
import DOCOnlineLanguageForm from "./DOCOnlineLanguageForm";
import "../../Interview.scss";

const DOCOnlineEducationAndLanguage = ({
  currentStep,
  setCurrentStep,
  docOnline,
  autoCompleteCourseData,
  autoCompleteSchoolData,
  setDocOnline,
  languages,
  languageLevels,
  errors
}) => {
  const { t } = useTranslation();


  

  

  function canAddNewEducationExperience() {
    let lastItemIndex = docOnline.educationAndTraining.length - 1;

    if (
      Object.keys(docOnline.educationAndTraining[lastItemIndex]).length === 0 ||
      Object.values(docOnline.educationAndTraining[lastItemIndex])
        .filter((item) => typeof item !== "boolean")
        .every((item) => item === undefined) === true
    ) {
      return false;
    } else {
      return true;
    }
  }

  function AddEducationExperience() {
    if (canAddNewEducationExperience()) {
      let _educationAndTraining = [...docOnline.educationAndTraining];
      _educationAndTraining.push({});
      setDocOnline({
        ...docOnline,
        educationAndTraining: _educationAndTraining
      });
    }
  }

  function DeleteEducationExperience(index) {
    let _educationAndTraining = [...docOnline.educationAndTraining];
    _educationAndTraining.splice(index, 1);
    setDocOnline({ ...docOnline, educationAndTraining: _educationAndTraining });
  }

  function AddOtherLanguage() {
    let lastItemIndex = docOnline.otherLanguages.length - 1;

    if (docOnline.otherLanguages.length > 0) {
      if (
        Object.values(docOnline.otherLanguages[lastItemIndex]).includes(0) ===
          true ||
        Object.keys(docOnline.otherLanguages[lastItemIndex]).length <= 1
      ) {
        return;
      }
    }

    let _otherLanguages = [...docOnline.otherLanguages];
    _otherLanguages.push({});
    setDocOnline({ ...docOnline, otherLanguages: _otherLanguages });
  }

  function DeleteOtherLanguage(index) {
    let _otherLanguages = [...docOnline.otherLanguages];
    _otherLanguages.splice(index, 1);
    setDocOnline({ ...docOnline, otherLanguages: _otherLanguages });
  }

  const onSelectedCourse = (courseId, index) => {
    let _educationAndTraining = [...docOnline.educationAndTraining];
    _educationAndTraining[index]["courseId"] = courseId;
    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });
  }

  const onSelectedSchool = (schoolId, index) => {
    let _educationAndTraining = [...docOnline.educationAndTraining];
    _educationAndTraining[index]["schoolId"] = schoolId;
    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });
  }

  function onChangeStartDate(date, index) {
    let _educationAndTraining = [...docOnline.educationAndTraining];

    _educationAndTraining[index]["startDate"] = date._d;
    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });
  }

  function onChangeEndDate(date, index) {
    let _educationAndTraining = [...docOnline.educationAndTraining];

    _educationAndTraining[index]["endDate"] = date._d;
    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });
  }

  function onChangeMotherLanguage({ target }) {
    let _docOnline = { ...docOnline };
    _docOnline["motherLanguage"] = parseInt(target.value);
    setDocOnline(_docOnline);
  }

  return (
   <>
      <h3 className="title-style">{t("Education and training")}</h3>
      <div className="doc-subtitle subtitle-style">
        {t(
          "Add and describe your learning experience here (university degrees, certifications, courses)."
        )}
      </div>
      <div className="card inboard p-4">
        <div className="doc-training">
          <h2>{t("Your education and training experience")}</h2>
          {docOnline &&
            docOnline.educationAndTraining &&
            docOnline.educationAndTraining.map((item, index) => {
              return (
                <DOCOnlineEducationForm
                  index={index}
                  onDelete={DeleteEducationExperience}
                  education={item}
                  onSelectedCourse={onSelectedCourse}
                  onSelectedSchool={onSelectedSchool}
                  onChangeStartDate={onChangeStartDate}
                  onChangeEndDate={onChangeEndDate}
                  docOnline={docOnline}
                  setDocOnline={setDocOnline}
                  errors={errors}
                  autoCompleteCourseData={autoCompleteCourseData}
                  autoCompleteSchoolData={autoCompleteSchoolData}
                />
              );
            })}
          {Object.keys(
            docOnline.educationAndTraining[
              docOnline.educationAndTraining.length - 1
            ]
          ).length === 0 ? (
            <div className="add-section-none">
              <button disabled type="button" className="app-button btn-prime btn-md position-button">
                {t("Add another education experience")}
              </button>
            </div>
          ) : (
            <div className="add-section" onClick={AddEducationExperience}>
              <button type="button" className="app-button btn-prime btn-md position-button">
                {t("Add another education experience")}
              </button>
            </div>
          )}
          <h2 className="mb-3 mt-2">{t("Language skills")}</h2>
          <div className="languages">
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Native Language")}<label className="star-style">*</label></label>
              </div>
              <select
                className="form-select mother-lang-edit"
                name="motherLanguage"
                onChange={onChangeMotherLanguage}
                value={docOnline.motherLanguage}
              >
                <option key={0} selected disabled value={0}>
                  {t("Add Language")}
                </option>
                {languages &&
                  languages.map((item) => (
                    <option key={item.id} value={item.id}>
                      {t(item.description)}
                    </option>
                  ))}
              </select>
            </div>
            {docOnline.otherLanguages &&
              docOnline.otherLanguages.map((item, index) => {
                return (
                  <DOCOnlineLanguageForm
                    index={index}
                    onDelete={DeleteOtherLanguage}
                    otherLanguage={item}
                    docOnline={docOnline}
                    setDocOnline={setDocOnline}
                    languages={languages}
                    languageLevels={languageLevels}
                    errors={errors}
                  />
                );
              })}
          </div>
          <div className="add-section">
          
            <button  type="button" className="app-button btn-prime btn-md position-button"  onClick={AddOtherLanguage}>
            {t("Add another language")}
              </button>
          </div>
        </div>
      </div>
      <div style={{color:"red"}}>
        <label className="star-style">*</label> <label style={{marginLeft:"20px"}}>{t("Required field")}</label>
      </div>
      
    </>
  );
};

export default DOCOnlineEducationAndLanguage;
